import { render } from "./FilteruploadedFiles.vue?vue&type=template&id=1b3e88ef&scoped=true"
import script from "./FilteruploadedFiles.vue?vue&type=script&lang=js"
export * from "./FilteruploadedFiles.vue?vue&type=script&lang=js"

import "./FilteruploadedFiles.vue?vue&type=style&index=0&id=1b3e88ef&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b3e88ef"]])

export default __exports__